<template>
	<div class="results-container custom-scrollbar" v-if="results && results.length > 0">
		<div class="results-wrapper">
			<div class="result"
				v-for="res in results"
				:key="res.id"
				@click="goToArticle(res.id)"
			>
				<SearchResultHighlight
					:textToHighlight="res.title"
					:searchPhrase="searchPhrase"
				/>
				<span class="text">in</span>
				<SearchResultPath :article="res" />
			</div>
		</div>
	</div>
</template>

<script>
import SearchResultPath from "./SearchResultPath";
import SearchResultHighlight from "./SearchResultHighlight";
export default {
	name: "SearchSuggest",
	components: {
		SearchResultPath,
		SearchResultHighlight,
	},
	props: ["results", "searchPhrase"],
	methods: {
		goToArticle: function (id) {
			this.$router.push({
				path: "article-view",
				query: { id },
			});
			this.$emit('resultselected');
		},
	},
};
</script>

<style scoped>
.results-container {
	position: absolute;
	top: 2.7rem;
	z-index: 52;
	width: 100%;
	max-height: 31rem;
	overflow: auto;
	box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
	background-color: var(--clr-background);
	border: 1px solid #CCC;
	border-radius: 0.3em;
}

.results-wrapper {
	width: 100%;
}

.result {
	display: flex;
	align-items: center;
	white-space: nowrap;
	padding: 1rem;
	width: 100%;
	overflow: hidden;
}

.result:hover {
	cursor: pointer;
	background-color: hsl(from var(--clr-accent-primary) h s 96% );
}

.text {
	margin-left: 0.4rem;
	margin-right: 0.4rem;
}
.no-results-wrapper {
}
</style>